module.exports = __webpack_public_path__ + "img/success-close.5f81f77b.svg";